/*global lightGallery zoomImages*/
import "lightgallery.js"
import "lg-zoom.js"
import { productSlider } from "./slider"

let state = {
  zoom: false
}

export const productZoom = () => {
  const slides = Array.from(document.querySelectorAll(".descriptionSlideImage"))

  const zoomEl = document.getElementById("lightgallery")
  if (slides.length > 0) {
    slides.map(slide => {
      slide.addEventListener("click", () => {
        const indexSlide = productSlider.realIndex
        lightGallery(zoomEl, {
          download: false,
          preload: 1,
          index: indexSlide,
          dynamic: true,
          loop: false,
          dynamicEl: createArray(slides)
          // dynamicEl: zoomImages
        })
        state.zoom = true
      })
    })
  }
}

export const productZoomDestroy = () => {
  const zoom = document.getElementById("lightgallery")
  window.lgData[zoom.getAttribute("lg-uid")].destroy()
}

const createArray = images => {
  return images.map((item, index) => {
    return {
      src: item.dataset.zoomimage
    }
  })
}
